import { SingleTableBoxScene } from "@/shared/components/ui";
import { useState } from "react";
import { a11yProps, sizeTab } from "@/shared";
import { CustomTabPanel } from "@/erp/sale";
import { Box, Tab, Tabs } from "@mui/material";
import TabTipoActividadNoc from "../../components/TabTipoActividadNoc";
import TabIncidenciasNoc from "../../components/TabIncidenciasNoc";

export default function ParametrosOrdenesNocPage() {

    const [valueTab, setValueTab] = useState(0);

    return (
        <>
            <SingleTableBoxScene
                title={`Parámetros`}
                urlRedirect={``}
                visibleReport={true}
            >
                <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
                    <Tabs
                        value={valueTab}
                        onChange={(_event: React.SyntheticEvent, newValue: number) => {
                            setValueTab(newValue);
                        }}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs ordenes trabajo noc"
                    >
                        <Tab label={'Tipos de Actividad'} {...a11yProps(0)} />
                        <Tab label={'Incidencias'} {...a11yProps(1)} />
                    </Tabs>
                </Box>

                <CustomTabPanel value={valueTab} index={0}>
                    <TabTipoActividadNoc />
                </CustomTabPanel>
                <CustomTabPanel value={valueTab} index={1}>
                    <TabIncidenciasNoc />
                </CustomTabPanel>
            </SingleTableBoxScene>
        </>
    )
}